import { isEnrollmentExpired } from './cohortAccess';

export interface PlanCohort {
  id: string;
  name: string;
  content_access_deadline: string | null;
  is_perpetual: boolean | null;
  programs: { name: string } | null;
  view_only?: boolean;
}

export function activePlanCohorts(cohorts: PlanCohort[], now = new Date()): PlanCohort[] {
  return cohorts.filter(c => !c.is_perpetual && !c.view_only && !isEnrollmentExpired(c, now));
}

export function shouldOfferPro(input: {
  hasPaidAccess: boolean; hasProAccess: boolean; hasEnterpriseAccess: boolean;
  loading: boolean; error: boolean;
}): boolean {
  return !input.loading && !input.error && !input.hasPaidAccess && !input.hasProAccess && !input.hasEnterpriseAccess;
}